import React from 'react';
import { HeartHandshake, TrendingUp, Users } from 'lucide-react';
import PhasePageTemplate from './PhasePageTemplate';

const PhaseSupport = () => (
  <PhasePageTemplate
    phaseNumber="06"
    phaseName="Ongoing Support"
    tagline="Your agent keeps getting better. You always have a direct line. And every Wednesday, your whole team gets smarter together."
    heroImage="/images/generated/process-hero-support.png"
    conceptImage="/images/generated/process-concept-support.png"
    delivers={[
      {
        icon: <HeartHandshake className="w-6 h-6" />,
        title: 'Direct Support Access',
        desc: 'Questions, troubleshooting, new workflows — you have a direct line. Most issues are resolved same day. Your agent isn\'t a product you purchased and got left with.',
      },
      {
        icon: <Users className="w-6 h-6" />,
        title: 'Winning Wednesday',
        desc: 'Every week, active RoofClaw clients join a live group session. New use cases, workflow coaching, Q&A, and the kind of practical advice you only get from people using the same system.',
      },
      {
        icon: <TrendingUp className="w-6 h-6" />,
        title: 'A System That Grows',
        desc: 'Your agent learns from how you use it. As your business evolves, your agent evolves. New integrations, new capabilities, new workflows — added as you need them.',
      },
    ]}
    whyTitle="The relationship doesn't end at delivery."
    whyBody="Most software companies want you to be self-sufficient so they can stop paying attention to you. We're the opposite. The more you use your agent, the more valuable it becomes — and we want to be there for that. Winning Wednesday exists because the best RoofClaw owners aren't just users, they're collaborators. They share what's working, ask hard questions, and push the system further every week. That community is part of what you paid for."
    experienceTitle="You have backup. Every day."
    experienceBody="After your Activation Call, you're never on your own. Winning Wednesday runs every week — it's a live group session where active clients bring real questions and leave with real answers. Between sessions, you have a direct line for anything urgent. As your business grows, your agent grows with it. New tools to connect, new workflows to build, new capabilities as the platform evolves. This isn't a product you bought once. It's a working relationship."
    experienceHighlights={[
      'Winning Wednesday — live every week, open to all active clients',
      'Direct messaging access for questions and troubleshooting',
      'New integrations and workflows added as your needs evolve',
      'You\'re building alongside other successful roofing operators — not alone',
    ]}
    timeline="Ongoing"
    mockupImage="/images/generated/mockup-morning-brief.jpg"
    mockupCaption="6 AM Monday. Your agent already handled it before you opened your eyes."
    todoItems={[
      'Show up to Winning Wednesday — it compounds over time',
      'Reach out when something isn\'t working — don\'t let it sit',
      'Tell us what you wish your agent could do — we\'re always building',
    ]}
    prevPhase={{ name: 'The Activation Call', href: '/process/activation' }}
    nextPhase={null}
  />
);

export default PhaseSupport;
